import { Label, PrimaryButton, Separator, Text } from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';
import { useTranslation } from 'react-i18next';

// models
import { Person } from '../../../models/Entities/Person/Person';
import { PersonTypeEnum } from '../../../models/Entities/Person/PersonCommands';

// components
import PersonFormComponent from './Person.Form.Component';

// functions
import * as CommonFunctions from '../Persons.Functions';

export interface IProps {
  Person: Person;
}

// Read only summary of the person data, editing is done through the person form.
export const PersonResumeComponent = (props: IProps) => {
  const [t] = useTranslation();
  const [isFormOpen, { setTrue: openForm, setFalse: dismissForm }] = useBoolean(false);

  const isJuridicalPerson = props.Person.personType === PersonTypeEnum.JuridicalPerson;

  const Row = (label: string, value: string) => (
    <div style={{ display: 'flex', flexDirection: 'column', minWidth: 220, marginBottom: 12 }}>
      <Label>{label}</Label>
      <Text>{value || '-'}</Text>
    </div>
  );

  return (
    <>
      <div className="ComponentHeaderControls">
        <PrimaryButton
          text={t('persons.resume.edit', { defaultValue: 'Editar datos personales' })}
          iconProps={{ iconName: 'Edit' }}
          onClick={openForm}
          className="actionButton"
        />
      </div>
      <Separator />

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 24 }}>
        {Row(
          t('persons.form.personType', { defaultValue: 'Tipo de persona' }),
          isJuridicalPerson
            ? t('persons.personType.juridical', { defaultValue: 'Persona jurídica' })
            : t('persons.personType.natural', { defaultValue: 'Persona física' })
        )}
        {Row(
          t('persons.resume.displayName', { defaultValue: 'Nombre' }),
          CommonFunctions.GetPersonDisplayName(props.Person)
        )}
        {!isJuridicalPerson &&
          Row(t('persons.form.firstName', { defaultValue: 'Nombre' }), props.Person.firstName || '')}
        {!isJuridicalPerson &&
          Row(t('persons.form.lastName', { defaultValue: 'Apellido' }), props.Person.lastName || '')}
        {!isJuridicalPerson &&
          Row(
            t('persons.form.birthDate', { defaultValue: 'Fecha de nacimiento' }),
            CommonFunctions.FormatDate(props.Person.birthDate)
          )}
        {!isJuridicalPerson &&
          Row(t('persons.form.birthPlace', { defaultValue: 'Lugar de nacimiento' }), props.Person.birthPlace || '')}
        {!isJuridicalPerson &&
          Row(t('persons.form.nationality', { defaultValue: 'Nacionalidad' }), props.Person.nationality || '')}
        {Row(t('persons.form.activity', { defaultValue: 'Actividad' }), props.Person.activity || '')}
        {Row(
          t('persons.resume.personIdentifier', { defaultValue: 'Identificador único' }),
          props.Person.personIdentifier || ''
        )}
      </div>

      <PersonFormComponent
        isOpen={isFormOpen}
        openPanel={openForm}
        dismissPanel={dismissForm}
        personId={props.Person.id}
      />
    </>
  );
};

export default PersonResumeComponent;
